export default __webpack_public_path__ + "static/media/nodeos.0fc06adc.svg";